import { ApiResponse } from 'apisauce';

import { generateApiClient } from '../api';
import { getGeneralApiProblem } from '../api/api-problem';
import { Product, ProductPrice } from '../../types/product';

const api = generateApiClient();

export const getProductsApi = async (query?: any): Promise<any> => {
  try {
    api.setHeader('Accept', `application/eshop.content.api.json`);
    const response: ApiResponse<any> = await api.get(`products${query}`);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;

    return { kind: 'ok', data: data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const createProductApi = async (product: Product): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.post(`products`, product);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const updateProductApi = async (id: number, product: Product): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.put(`products/${id}`, product);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const getProductByIdApi = async (id: number): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.get(`products/${id}`);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const getProductPricesByIdApi = async (id: number, query?: any): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.get(`products/${id}/prices${query}`);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const createProductPriceApi = async (productId: number, price: ProductPrice): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.post(`products/${productId}/prices`, price);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const updateProductPriceApi = async (productId: number, priceId: number, price: ProductPrice): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.put(`products/${productId}/prices/${priceId}`, price);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};
